import styled from "@emotion/styled";
import { Chip } from "@mui/material";

const Wrapper = styled.div`
  font-size: 18px;
  font-weight: 500;

  display: flex;
  flex-direction: column;

  ${({ between }) =>
    between &&
    `
      justify-content: space-between;
      flex-direction: row;
  `};
  row-gap: 6px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-direction: row;
    justify-content: start;
    gap: ${p => p.theme.space[6]}px;
  }
`;

const Heading = styled.p`
  margin: 0;
  min-width: 150px;
  max-width: 150px;
  color: ${({ theme }) => theme.colors.secondary.gray};
`;

const Label = styled(Chip, {
  shouldForwardProp: prop => prop !== "labelStatus",
})`
  width: max-content;
  height: max-content;
  background-color: ${({ labelStatus, theme }) =>
    labelStatus ? theme.colors.accent.green : theme.colors.background};

  span {
    white-space: pre-wrap;
  }
`;

const BoxLabel = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.secondary.main};
  ${({ isBoxLabel }) => isBoxLabel && `margin-top:  6px`};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    padding-left: ${({ isBoxLabel }) => (isBoxLabel ? "174px" : 0)};
    ${({ isBoxLabel }) => isBoxLabel && `margin-top:  8px;`}
  }
`;

const ListLabel = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const CountyWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export { Wrapper, Heading, Label, BoxLabel, ListLabel, CountyWrapper };
